import styled from 'styled-components';
import { generateClassNames, applyDisplayNames } from '../../utils/functions';
var baseClassName = 'PopupStatus';
var PopupStatus = /*#__PURE__*/styled.span.attrs({
  className: generateClassNames(baseClassName, 'root')
}).withConfig({
  componentId: "sc-qash56-0"
})(["display:flex;"]);
var Styled = applyDisplayNames({
  PopupStatus: PopupStatus
});
export default Styled;